// extracted by mini-css-extract-plugin
export default {"formInput":"MasterProcessNewForm_formInput__gA694"};